export const loadIntercom = (appId: string): void => {
  const w = window as any;
  const ic = w.Intercom;
  if (typeof ic === "function") {
    ic("reattach_activator");
    ic("update", w.intercomSettings);
  } else {
    const d = document;
    const i: any = function () {
      i.c(arguments);
    };
    i.q = [];
    i.c = function (args: any) {
      i.q.push(args);
    };
    w.Intercom = i;
    const l = () => {
      const s = d.createElement("script");
      s.type = "text/javascript";
      s.async = true;
      s.src = `https://widget.intercom.io/widget/${appId}`;
      const x = d.getElementsByTagName("script")[0];
      if (x && x.parentNode) {
        x.parentNode.insertBefore(s, x);
      } else {
        d.head.appendChild(s);
      }
    };
    l();
  }
};

export const bootIntercom = (appId: string): void => {
  console.log("[Intercom] Booting widget with App ID:", appId);
  if (window.Intercom) {
    window.Intercom("boot", {
      app_id: appId,
      hide_default_launcher: true,
    });
  } else {
    console.warn("[Intercom] window.Intercom is not defined during boot!");
  }
};

export const updateIntercom = (): void => {
  if (window.Intercom) {
    window.Intercom("update");
  }
};

export const showIntercom = (): void => {
  console.log("[Intercom] show called. Current API function:", window.Intercom);
  if (window.Intercom) {
    window.Intercom("show");
  } else {
    console.warn("[Intercom] window.Intercom is not defined during show!");
  }
};
